/**
 * Represents the dimensions of an element.
 */
export class ElementDimensions {
    /**
     * The width of the element.
     */
    Width: number;

    /**
     * The height of the element.
     */
    Height: number;

    /**
     * The offset from the top of the element.
     */
    OffsetTop: number;

    /**
     * The offset from the left of the element.
     */
    OffsetLeft: number;

    /**
     * Constructs a new instance of the ElementDimensions class.
     * @param width The width of the element.
     * @param height The height of the element.
     * @param offsetTop The offset from the top of the element.
     * @param offsetLeft The offset from the left of the element.
     */
    constructor(width: number, height: number, offsetTop: number, offsetLeft: number) {
        this.Width = width;
        this.Height = height;
        this.OffsetTop = offsetTop;
        this.OffsetLeft = offsetLeft;
    }
}